"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCopyrightContent = exports.StyledFooterSocialLink = exports.StyledFooterNavListItem = exports.StyledFooterNavList = exports.StyledFooterNav = exports.StyledFooterWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const paragraph_1 = require("~components/paragraph");
exports.StyledFooterWrapper = styled_components_1.default.footer.withConfig({ displayName: "StyledFooterWrapper", componentId: "sc-1alc3eq" }) `
  background: ${(props) => (0, ui_1.hexToRgba)(props.theme.colors.cultured, 0.6)};

  ${(props) => (0, ui_1.mq)({
    padding: [`${props.theme.spacers.x6} 0`, null, `${props.theme.spacers.x12} 0`],
})}
`;
exports.StyledFooterNav = styled_components_1.default.nav.withConfig({ displayName: "StyledFooterNav", componentId: "sc-1lxqlwd" }) ``;
exports.StyledFooterNavList = styled_components_1.default.ul.withConfig({ displayName: "StyledFooterNavList", componentId: "sc-a6cab" }) `
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: ${(props) => props.theme.spacers.x1};

  ${(props) => (0, ui_1.mq)({
    columnGap: [props.theme.spacers.x2, props.theme.spacers.x3],
    justifyContent: ['center', null, 'flex-start'],
})}
`;
exports.StyledFooterNavListItem = styled_components_1.default.li.withConfig({ displayName: "StyledFooterNavListItem", componentId: "sc-ggkf17" }) `
  a {
    ${(props) => props.theme.responsiveFontsize.body.medium}
    text-decoration: none;
    color: ${(props) => props.theme.colors.oxfordBlue};

    &:hover {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }
`;
exports.StyledFooterSocialLink = styled_components_1.default.a.withConfig({ displayName: "StyledFooterSocialLink", componentId: "sc-1jxw3cx" }) `
  display: flex;
  text-decoration: none;
  color: ${(props) => props.theme.colors.oxfordBlue};

  &:hover {
    color: ${(props) => props.theme.colors.celticBlue};
  }
`;
exports.StyledCopyrightContent = (0, styled_components_1.default)(paragraph_1.Paragraph).withConfig({ displayName: "StyledCopyrightContent", componentId: "sc-1yui5es" }) `
  ${(props) => (0, ui_1.mq)({
    paddingTop: [props.theme.spacers.x3, null, props.theme.spacers.x4],
    paddingLeft: [0, null, '215px'],
    textAlign: ['center', null, 'left'],
})}
`;
